export interface DialogData {
    title: string;
    confirmBtnOverride?: string;
    closeBtnOverride?: string;
}

export interface TextDialogData extends DialogData {
    text?: string | string [];
}

export interface TextAreaDialogData extends TextDialogData {
    label: string;
}

export enum SimpleInputDialogType {
    TEXT = 'text',
    NUMBER = 'number',
    PASSWORD = 'password'
}

export interface SimpleInputDialogData extends TextAreaDialogData {
    inputType: SimpleInputDialogType;
}
